import { RichSelect } from 'common-front/src/designSystem/form/richSelect';
import { useHeavent } from 'common-front/src/hooks/useHeavent';
import * as React from 'react';
import { useWorkflowVolunteersSegmentsQuery } from '../../../generated/graphqlHooks';
import { WorkflowBox } from '../workflowBox';

interface IWorkflowVolunteersSegmentStepProps {
    hasBeenExecuted: boolean;
    isEdit: boolean;
}

export const WorkflowVolunteersSegmentStep = (props: IWorkflowVolunteersSegmentStepProps) => {
    const {
        translate,
        params: { eventId }
    } = useHeavent();
    const { data } = useWorkflowVolunteersSegmentsQuery({ eventId });

    return (
        <WorkflowBox
            category={translate('liste_des_membr_89037')}
            icon="user-group"
            title={translate('une_vue_parmi_l_98342')}
        >
            <RichSelect
                isSearchVisible={true}
                name="workflow.data.volunteersSegmentId"
                placeholder={translate('choisir_une_vue_98781')}
                state={props.isEdit && props.hasBeenExecuted ? 'disabled' : 'active'}
            >
                {(data.event?.segmentsFolders ?? []).map((segmentFolder) => (
                    <optgroup key={segmentFolder.id} label={segmentFolder.name}>
                        {segmentFolder.segments.map((segment) => (
                            <option key={segment.id} value={segment.id}>
                                {segment.name}
                            </option>
                        ))}
                    </optgroup>
                ))}
            </RichSelect>
        </WorkflowBox>
    );
};
